import { FC } from 'react';

// Залитая иконка панели — показывается, когда сайдбар деталей открыт.
export const PanelFilledIcon: FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2000 2000"
    preserveAspectRatio="xMidYMid meet"
    width="16"
    height="16"
    style={style}
  >
    <g fill="currentColor">
      <path
        d="M2690 19459 c-521 -40 -1022 -255 -1397 -601 -417 -385 -668 -873 -745 -1453 -11 -82 -13 -1383 -13 -7410 0 -6960 1 -7316 18 -7434 159 -1112 1029 -1934 2137 -2020 152 -12 14468 -12 14620 0 598 47 1129 304 1546 749 311 333 522 786 591 1270 17 119 18 474 18 7435 0 6027 -2 7328 -13 7410 -67 504 -270 949 -593 1300 -379 412 -836 651 -1419 743 -97 15 -669 17 -7375 18 -3999 1 -7317 -2 -7375 -7z m10880 -9459 l0 -7680 -5357 0 c-3337 1 -5386 4 -5433 10 -224 29 -421 226 -450 450 -13 101 -13 14338 0 14437 29 226 222 424 442 452 34 5 2478 9 5431 10 l5367 1 0 -7680z"
        transform="matrix(.1 0 0 -.1 0 2000)"
        fill="currentColor"
        stroke="none"
      />
    </g>
  </svg>
);

// Контурная иконка панели — показывается, когда сайдбар деталей свёрнут.
export const PanelOutlineIcon: FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2000 2000"
    preserveAspectRatio="xMidYMid meet"
    width="16"
    height="16"
    style={style}
  >
    <g fill="currentColor">
      <path
        d="M2710 19280 c-281 -19 -572 -99 -823 -227 -402 -206 -734 -538 -940 -940 -132 -259 -206 -530 -227 -838 -13 -189 -13 -14347 0 -14545 41 -628 319 -1157 820 -1563 141 -114 373 -245 550 -311 222 -81 400 -120 635 -136 189 -13 14347 -13 14545 0 238 16 416 54 640 136 177 66 409 197 550 311 501 406 779 935 820 1563 12 177 11 14391 0 14560 -52 750 -494 1419 -1167 1763 -251 128 -537 207 -823 227 -146 10 -14425 10 -14580 0z m10145 -9280 l0 -7855 -4980 -3 c-3032 -1 -5017 1 -5076 7 -350 34 -613 293 -650 640 -12 115 -12 14307 0 14422 18 171 87 316 207 434 118 117 264 188 419 205 39 4 2322 7 5075 6 l5005 -1 0 -7855z m4356 7851 c170 -18 311 -85 433 -206 120 -118 189 -263 207 -434 12 -115 12 -14307 0 -14422 -18 -170 -85 -311 -206 -433 -118 -120 -263 -189 -434 -207 -47 -5 -724 -9 -1503 -9 l-1418 0 0 7860 0 7860 1418 0 c779 0 1456 -4 1503 -9z"
        transform="matrix(.1 0 0 -.1 0 2000)"
        fill="currentColor"
        stroke="none"
      />
    </g>
  </svg>
);
